import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "../../default-styles/Global/Global.js";
import { DatePickerGlobalStyle } from "../DatePicker/DatePickerGlobalStyle.js";
import { defaultTheme } from "./Theme.constants.js";
import { ThemeProps } from "./Theme.types.js";
import { mergeThemes } from "./helpers/mergeThemes.js";

export function Theme({ children, theme, useFontSizeScale = true, addMainBackground = true, skipGlobalStyles = false }: ThemeProps): JSX.Element {
    const formattedTheme = theme ? mergeThemes(defaultTheme, theme) : defaultTheme;

    return (
        <ThemeProvider theme={formattedTheme}>
            <>
                {!skipGlobalStyles && (
                    <>
                        <GlobalStyle
                            useFontSizeScale={useFontSizeScale}
                            addMainBackground={addMainBackground}
                            mainFontColor={formattedTheme.grayscale[100]}
                        />
                        <DatePickerGlobalStyle />
                    </>
                )}
                {children}
            </>
        </ThemeProvider>
    );
}
